import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { signUpUrl } from '../../constants/appUrls';
import { login } from '../../utils/sideEffects';
import checkValidity from '../../utils/validation';
import AuthContext from '../../contexts/AuthContext';

import Button from '../../components/UI/Button';
import Input from '../../components/UI/Input';
import Spinner from '../../components/UI/Spinner';

class Login extends Component {

    static contextType = AuthContext;

    state = {
        loginForm: {
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: 'E-mail',
                },
                value: '',
                validation: {
                    isEmail: true,
                    required: true,
                },
                isValid: false,
                touched: false,
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password',
                    autoComplete: '',
                },
                value: '',
                validation: {
                    isPassword: true,
                    minLength: 8,
                    required: true,
                },
                isValid: false,
                touched: false,
            },
        },
        isFormValid: false,
        isLoading: false,
        error: null,
    }

    formSubmitHandler = async event => {
        this.setState({ isLoading: true });
        event.preventDefault();
        let formData = {};
        for (let key in this.state.loginForm) {
            formData = {
                ...formData,
                [key]: this.state.loginForm[key].value
            }
        }
        const result = await login(formData);
        if (result.status !== 200) {
            this.setState({ error: result.data, isLoading: false });
        } else {
            const { token, userId, firstName, lastName, expiresIn } = result.data.authData;
            this.context.login(token, userId, firstName, lastName, expiresIn);
            this.props.history.replace('/');
        }
    }

    inputChangeHandler = (key, event) => {
        const form = { ...this.state.loginForm };
        const element = { ...form[key] };
        element.value = event.target.value;
        element.isValid = checkValidity(event.target.value, element.validation);
        element.touched = true;
        form[key] = element;
        let isFormValid = true;
        for (key in form) {
            isFormValid = form[key].isValid && isFormValid;
        }
        this.setState({ loginForm: form, isFormValid: isFormValid });
    }

    componentDidMount() {
        if (this.context.isLoggedIn) {
            this.props.history.replace('/');
        }
    }

    render() {

        const formElements = [];
        for (let key in this.state.loginForm) {
            formElements.push({
                id: key,
                config: this.state.loginForm[key]
            })
        }

        let form = <form className="form" onSubmit={this.formSubmitHandler}>
            <h1 className="form__title">LOGIN</h1>
            {this.state.error && <p className="form__error">{this.state.error.status}: {this.state.error.message}</p>}
            {formElements.map(element => {
                return <Input
                    key={element.id}
                    elementType={element.config.elementType}
                    value={element.config.value}
                    isValid={element.config.isValid}
                    touched={element.config.touched}
                    elementConfig={element.config.elementConfig}
                    changed={(event) => { this.inputChangeHandler(element.id, event) }} />
            })}
            <Button className="form__btn btn" type="submit">Login</Button>
            <p className="form__link">Don't have an account? <NavLink to={signUpUrl}><span>Sign-Up</span></NavLink></p>
        </form>;

        if (this.state.isLoading)
            form = <Spinner />

        return form;
    }

}

export default Login;